import React from 'react';

import { Section, preloader } from 'spectacle-ppa';

import headingSlide from '../../baseSlides/headingSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import imageEPSLogo from '../../images/emergencyPreparednessSquadGlow.png';
import apprenticeFistUp from '../../images/characters/apprenticeFistUp.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_assemblyMission.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) }
};

export function preloadMissionAssignment () {
  preloader([
    imageEPSLogo,
    apprenticeFistUp
  ]);
}

function missionAssignmentSection ({ level, regionData }) {
  const md = levels[level].md;
  return (
    <Section id="mission-assignment">

      {/* Sizzle */}
      {headingSlide({
        id: 'sizzle',
        beforeImage: imageEPSLogo,
        subHeading: 'Your Mission',
        notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
        bgColor: 'black'
      })}

      {/* Mission Instructions */}
      {balloonSlide({
        id: 'instructions',
        characterSide: 'right',
        characterImage: apprenticeFistUp,
        notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
      })}

    </Section>
  );
}

export default missionAssignmentSection;



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/sections/70_missionAssignment/missionAssignmentSection.jsx